import React from 'react';
import classNames from 'classnames';
import MsgConfigSection from '../msg-config-section';
import { MessageConfigItem } from '../../../../interfaces';
import { platformIntl } from '../../../../../../constants';

interface WebsocketMsgConfigProps {
    className?: string;
    config?: MessageConfigItem;
    onUpdateConfig: (config: MessageConfigItem) => void;
}

/**
 * Websocket消息渠道配置
 * 就是站内的右上角消息弹窗
 */
const WebsocketMsgConfig: React.FC<WebsocketMsgConfigProps> = (props) => {
    const { className, config, onUpdateConfig } = props;

    if (!config) {
        return null;
    }

    return (
        <MsgConfigSection
            className={classNames('fx-websocket-msg-config', className)}
            messageChannel="ws"
            checkProps={{
                checked: config.enable,
                text: platformIntl.get('msg.notification'),
                onCheck: (value) => {
                    onUpdateConfig({ ...config, enable: value });
                }
            }}
            receiverProps={{
                editable: false
            }}
            customOperation={
                <div className="description-font">{platformIntl.get('msg.notification.tip')}</div>
            }
        />
    );
};

export default WebsocketMsgConfig;
